/**
 * Is the package dialog showing a PMS preview?
 *
 * `previewPackageAdId` is the operator's param — PMS links it from the package
 * ads list so a hidden ad (inactive, draft, out of window) can be inspected.
 * `packageAdId` is the guest-facing deeplink and must never switch preview
 * reads on. The dialog can also be open on a different package while the param
 * still sits in the URL, so the id has to match what is actually open.
 */
export const isPackagePreview = ({
  previewPackageAdId,
  openPackageId,
}: {
  previewPackageAdId: string | null;
  openPackageId: string | undefined;
}): boolean =>
  !!previewPackageAdId && !!openPackageId && previewPackageAdId === openPackageId;

/**
 * `preview` as a query VARIABLE: `true`, or absent entirely.
 *
 * React Query hashes the variables object and `JSON.stringify` drops undefined
 * properties, so an ordinary guest's key stays byte-identical to what it was
 * before preview existed. Passing `false` forks every guest key away from
 * callers that omit the field — the package card's hover prefetch
 * (`PackageGrid`) is one — which wastes the prefetch and refetches the detail
 * when the dialog opens.
 */
export const previewVariable = (isPreview: boolean): true | undefined =>
  isPreview || undefined;
